export default __webpack_public_path__ + "static/media/X Icon.691913f5.svg";